import { IconProps } from '.';

export const TrophyIcon = ({ color = 'currentColor', className, onClick }: IconProps) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width='16'
      height='15'
      viewBox='0 0 16 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.5007 5.85352L12.4656 6.06152C12.0544 8.19298 10.1852 9.75 7.99487 9.75V8.25C9.51086 8.25 10.7974 7.13774 11.0164 5.6377L11.5105 2.25H4.47925L4.97339 5.6377C5.19236 7.13774 6.47889 8.25 7.99487 8.25V9.75C5.73393 9.75 3.81528 8.0908 3.48901 5.85352L2.74487 0.75H13.2449L12.5007 5.85352Z'
        fill={color}
      />
      <path
        opacity='0.72'
        d='M7.54523 9C7.54523 10.6151 7.06704 12.1942 6.1712 13.5381L5.91924 13.916L4.67119 13.084L4.92315 12.7061C5.65472 11.6086 6.04522 10.3189 6.04522 9H7.54523ZM9.94465 9C9.94465 10.319 10.3351 11.6086 11.0667 12.7061L11.3187 13.084L10.0706 13.916L9.81867 13.5381C8.92277 12.1942 8.44464 10.6151 8.44464 9H9.94465ZM3.49443 3H1.53446L1.75712 3.66699C2.22159 5.06018 3.52587 5.99986 4.99444 6V7.5C2.88033 7.49986 1.00299 6.14714 0.334265 4.1416L0.0735215 3.36035C-0.231362 2.44549 0.450073 1.50026 1.41435 1.5H3.49443V3ZM14.5745 1.5C15.539 1.50004 16.2204 2.44535 15.9154 3.36035L15.6546 4.1416C14.9858 6.14719 13.1087 7.5 10.9945 7.5V6C12.4631 6 13.7672 5.06023 14.2318 3.66699L14.4544 3H12.4945V1.5H14.5745Z'
        fill={color}
      />
      <path
        d='M12.4949 12.75C12.9091 12.75 13.2449 13.0858 13.2449 13.5C13.2449 13.9142 12.9091 14.25 12.4949 14.25H3.49487C3.08066 14.25 2.74487 13.9142 2.74487 13.5C2.74487 13.0858 3.08066 12.75 3.49487 12.75H12.4949Z'
        fill={color}
      />
    </svg>
  );
};
